import { Dialog, DialogContent, Grid, IconButton, makeStyles, Typography } from "@material-ui/core";
import React, { useState } from "react";
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(() => ({
    paper: {
        maxWidth: '550px',
    },
}));

export const TakeoverBanner = (props) => {
    const classes = useStyles();
    const { isTakeOverBanner, takeoverBannerData } = props;
    const [takeoverBanner, setTakeoverBanner] = useState(isTakeOverBanner);
    const handleClose = () => {
        setTakeoverBanner(false);
    }

    return (
        <Dialog
            open={takeoverBanner}
            onClose={handleClose}
            PaperProps={{
                className: classes.paper,
            }}
        >
            <IconButton aria-label="close" style={{ position: 'absolute', right: '10px', top: '15px', borderRadius: 0, height: "25px", width: "25px", background: "#E6E6E6" }} onClick={handleClose}>
                <CloseIcon style={{ color: "#000" }} />
            </IconButton>
            <DialogContent>
                <Grid container spacing={2} style={{ height: "auto", width: "auto" }} >
                    <Grid item sm={12}>
                        <Grid container>
                            <Typography style={{ fontWeight: 700, fontSize: '20px', margin: "10px 0px 10px 0px" }}>
                                <div dangerouslySetInnerHTML={{ __html: takeoverBannerData[0].Heading }} />
                            </Typography>
                            <div dangerouslySetInnerHTML={{ __html: takeoverBannerData[0].SubHeading }} />
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}